import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';
import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { convertDateToLocalDate, convertDateToLocalTime } from '@dreryk/react-common';

import { getInitialEstimatedDuration } from '../../shared/form/fields/EstimatedDurationField.utils';
import { AppointmentWaitlistCreateFormInitializer } from '../../create/waitlist/AppointmentWaitlistCreateForm.types';

export const appointmentWaitlistUpdateFormInitializer = (
   appointmentDetails: AppointmentDetails,
   healthcareLocationProviders: HealthcareProviderLocation[],
   patient: PatientSimple
): AppointmentWaitlistCreateFormInitializer => () => {
   const findHealthcareProviderLocation = (): HealthcareProviderLocation | null => {
      return (
         healthcareLocationProviders.find(
            (location) =>
               location.locationIdentifier.locationId === appointmentDetails.location?.locationId &&
               location.locationIdentifier.type === appointmentDetails.location.type
         ) ?? null
      );
   };

   const getHealthcareProviderLocationIfSingle = (): HealthcareProviderLocation | null => {
      if (healthcareLocationProviders.length === 1) {
         return healthcareLocationProviders[0];
      }

      return null;
   };

   const startTime = convertDateToLocalTime(appointmentDetails.beginDate).withSecond(0).withNano(0);
   const endTime = convertDateToLocalTime(appointmentDetails.endDate).withSecond(0).withNano(0);
   const date = convertDateToLocalDate(appointmentDetails.beginDate);

   return {
      healthcareProviderLocation: findHealthcareProviderLocation() ?? getHealthcareProviderLocationIfSingle(),
      dateConfirmedWithPatient: false,
      videoConsultation: appointmentDetails.encounterMode === 'VIDEO_CONSULTATION',
      startTime: startTime,
      endTime: endTime,
      date: date,
      estimatedDuration: getInitialEstimatedDuration(startTime, endTime, date),
      patient: patient,
      note: appointmentDetails.note ?? null,
      practitioner: appointmentDetails.practitioner,
      receptionService: {
         selector: [],
         value: appointmentDetails.receptionServices.map((receptionService) => ({
            receptionService: receptionService,
         })),
      },
   };
};
